  <div class="section-brands container-fluid" *ngIf="images">
    <div class="navbar navbar-expand-xg navbar-expand-lg navbar-expand-md align-items-center top-content">
      <div class="col-xg-12 col-lg-12 col-md-12 col-xs-12" style="background-color: #fff">
        <p class="pt-5 title-black"> NUESTROS PARTNERS</p>
        <!-- <usb-carousel> (reemplaza ngx-owl-carousel-o): la mecánica (autoplay, flechas,
             breakpoints) la maneja el componente compartido; acá solo se define cómo se ve cada
             slide (#slideTemplate) y se reposicionan las flechas por defecto vía CSS custom
             properties para que queden igual que las de owl. -->
        <usb-carousel *ngIf="images"
                       [items]="images"
                       [breakpoints]="brandsCarouselBreakpoints"
                       [autoplay]="true"
                       [showArrows]="false"
                       [autoplayInterval]="3000"
                       style="--usb-carousel-arrow-top: 55%; --usb-carousel-arrow-height: 100px; --usb-carousel-arrow-size: 40px; --usb-carousel-arrow-offset-left: -15px; --usb-carousel-arrow-offset-right: -35px;">
          <ng-template #slideTemplate let-image>
            <img loading="lazy" class="brands-carousel-img" [src]="image" alt="">
          </ng-template>
        </usb-carousel>
      </div>
    </div>
  </div>
